import { red } from '@mui/material/colors';

export const MUIThemeConfiguration = {
	/**
	 * @see https://material-ui.com/customization/themes/#theme-configuration-variables
	 */
	palette: {
		mode: 'dark',
		primary: {
			main: '#338FEE',
		},
	},
	MuiButton: {
		variants: [
			{
				props: { variant: 'bold' },
				style: {
					fontFamily: 'Eurostile',
				},
			},
		],
	},
	typography: {
		button: {
			textTransform: 'none',
		},
		h1: {
			fontFamily: 'Eurostile',
			fontSize: '20px',
			fontWeight: 'bold',
		},
		h2: {
			fontFamily: ['Eurostile Extended '].join(','),
			fontSize: 'calc(0.6vw + 0.6vh + 0.6vmin)',
			fontWeight: 'normal',
		},
		h3: {
			font: 'normal normal normal 12px/14px Eurostile',
			// fontFamily: ['Eurostile'].join(','),
			// fontSize: '1.6vw',
			// fontWeight: 'normal',
		},
	},
	components: {
		MuiUseMediaQuery: {
			defaultProps: {
				noSsr: true,
			},
		},
		MuiButton: {
			styleOverrides: {
				root: {
					borderRadius: '20px',
				},
			},
		},
	},
};
